import React from 'react';
import { AugmentedStore } from 'ia-react-core/~/interfaces/AugmentedStore';

interface ScopeContextProps {
  scope: string[];
  store?: AugmentedStore<any>;
}

const ScopeContext = React.createContext<ScopeContextProps>({ scope: [] });

export default ScopeContext;
